import { get } from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'jsonDecode' })
export class JsonDecode implements PipeTransform {
  transform(str: string, path) {
    const obj = JSON.parse(str);
    const val = get(obj, path);
    return val;
  }
}
